import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=31580a0a&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31580a0a",
  null
  
)

export default component.exports